import { Reveal } from "./Reveal";
import { MANIFESTO } from "../lib/content";

export const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto"
    className="relative py-24 lg:py-36 bg-brand-ink text-brand-cream overflow-hidden"
  >
    <div className="grain opacity-30" />
    <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="text-xs font-semibold tracking-[0.25em] text-brand-gold uppercase mb-16">
          Our promise
        </p>
      </Reveal>

      <div className="space-y-20 lg:space-y-28">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n} delay={0.05}>
            <div className="relative grid lg:grid-cols-12 gap-6 items-start">
              <span className="lg:col-span-3 font-serif text-7xl sm:text-8xl text-brand-gold/25 leading-none">
                {m.n}
              </span>
              <div className="lg:col-span-9">
                <h3 className="font-serif font-light text-3xl sm:text-5xl leading-[1.05] tracking-tight mb-5">
                  {m.title}
                </h3>
                <p className="text-brand-cream/70 text-base sm:text-lg leading-relaxed max-w-2xl">
                  {m.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
